<template>
	<div class="card">
		<div class="card-body">
			<div class="d-flex flex-wrap flex-column align-items-center">
				<a-avatar :src="cardAvatarSrc" :size="80" @error="cardAvatarBroken = true">
					<template #icon>
						<a-icon type="user" />
					</template>
				</a-avatar>

				<div class="text-center">
					<div class="text-dark font-weight-bold font-size-18">
						{{ data.username }}
					</div>
					<div class="text-uppercase font-size-12 mb-3">
						{{ auth().role(data.role) }}
					</div>

					<a-dropdown-button @click="goTo">
						Ver ficha

						<template #overlay>
							<a-menu @click="setOption">
								<a-menu-item v-if="auth().check('superadmin')" key="superadmin">
									<a-icon type="crown" /> Superadmin
								</a-menu-item>
								<a-menu-item v-if="auth().check('admin')" key="admin">
									<a-icon type="crown" /> Admin
								</a-menu-item>
								<a-menu-item v-if="auth().check('partner')" key="partner">
									<a-icon type="aliwangwang" /> Partner
								</a-menu-item>
								<a-menu-item v-if="auth().check('editor')" key="editor">
									<a-icon type="aliwangwang" /> Editor
								</a-menu-item>
								<a-menu-item v-if="auth().check('user')" key="user">
									<a-icon type="user" /> Usuario
								</a-menu-item>
								<a-menu-divider />
								<a-menu-item v-if="auth().check('editor')" key="unverified">
									<a-icon type="lock" /> Bloquear
								</a-menu-item>
								<a-menu-item v-if="auth().check('admin')" key="deleted">
									<a-icon type="delete" /> Borrar
								</a-menu-item>
							</a-menu>
						</template>
					</a-dropdown-button>
				</div>
			</div>
		</div>

		<a-modal v-model:visible="deleteModal.enabled" :width="440" ok-text="Eliminar" ok-type="danger" cancel-text="Cancelar" @ok="deleteUser" @cancel="deleteModal.enabled = false">
			<div class="mt-5 mb-3 text-uppercase text-dark text-center font-weight-bold">
				Introduce tu contraseña para confirmar la acción
			</div>
			<a-input ref="password" v-model:value="deleteModal.password" type="password" placeholder="Contraseña">
				<template #prefix>
					<a-icon type="lock" />
				</template>
			</a-input>
		</a-modal>
	</div>
</template>

<script>
import _ from 'lodash';
import { h } from 'vue';

const placeholder = require('../../../assets/img/placeholder/avatar.jpg');

export default {
	name: 'UserCard',
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			cardAvatarBroken: false,
			deleteModal: {
				enabled: false,
				password: '',
			},
		};
	},
	computed: {
		cardAvatarSrc() {
			return this.cardAvatarBroken ? placeholder : this.images().avatar(this.data);
		},
	},
	watch: {
		data() { this.cardAvatarBroken = false; },
	},
	methods: {
		goTo() {
			this.$router.push({ name: 'user', params: { id: this.data.id } });
		},
		setOption(e) {
			const self = this;

			switch (e.key) {
			case 'superadmin': case 'admin': case 'editor': case 'user': case 'partner':
				this.$modal.confirm({
					title: '¿Estas seguro de querer cambiar el estado de este usuario?',
					content: () => h('div', { style: 'color:red;' }, ['Obtendra el estado ', h('b', this.auth().role(e.key))]),
					onOk() { self.setStatus(e.key); },
					okText: 'Modificar',
				});
				break;

			case 'unverified':
				this.$modal.confirm({
					title: '¿Estas seguro de querer bloquear a este usuario?',
					content: () => h('div', { style: 'color:red;' }, 'No podrá acceder a la plataforma ni interactuar en ella'),
					onOk() { self.setStatus(e.key); },
					okText: 'Bloquear',
				});
				break;

			case 'deleted':
				this.deleteModal.enabled = true;
				setTimeout(() => { this.$refs.password.focus(); }, 300);
				break;

			default:
			}
		},
		async setStatus(status) {
			const { id } = this.data;
			if (id !== this.$store.getters.user.id) {
				const result = await this.$sdk.users().edit({ userId: id, role: status });

				const params = { ..._.cloneDeep(this.data), role: status };

				if (result) {
					this.$store.dispatch('setItem', { id, data: params, type: 'users' });
					this.$message.success(`Se modificó el estado del usuario a ${this.auth().role(status)}`);
				}
			} else {
				this.$message.error('No puedes cambiar el estado de tu propio usuario');
			}
		},
		async deleteUser() {
			if (this.deleteModal.password) {
				const { id } = this.data;
				if (id !== this.$store.getters.user.id) {
					const result = await this.$sdk.users().delete({ userId: id, password: this.deleteModal.password });

					if (result) {
						this.$store.dispatch('removeItem', { id, type: 'users' });
						this.$message.success('Usuario eliminado correctamente');
						if (this.$route.name === 'user' && this.$route.params.id === id) this.$router.replace({ name: 'users' });
					}
				} else {
					this.$message.error('Por motivos de seguridad no puedes borrar tu propio usuario desde el panel');
				}

				this.deleteModal.enabled = false;
				this.deleteModal.password = '';
			}
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
